import { DocsCallout, DocsSteps } from "../components"

<DocsSteps>
  <li>Connect Google or Meta from Accounts.</li>
  <li>Return to the site workspace and link the provider account to the site.</li>
  <li>For Google, link Ads for launch and GA4 for measurement.</li>
  <li>For Meta, link the ad account and confirm the selected page/pixel during launch setup.</li>
</DocsSteps>

<DocsCallout title="Auth boundary">
  Product authentication and provider authentication stay separate. Removing a provider connection
  should not affect the user's Adgiro login.
</DocsCallout>

Provider credential, API enablement, and permission problems should be fixed at the provider or
connection level. Adgiro should surface the provider error rather than silently changing campaign
behavior.
